import { connect } from 'react-redux';
import Cokie from './Cokie';


let mapStateToProps = (state) => {
  return {
    shopName: state.aboutPage.aboutData.shopName,
    domain: state.aboutPage.aboutData.domain,
  }
}

let mapDispatchToProps = (dispatch) => {
  return {
  }
}

const CokieContainer = connect(mapStateToProps, mapDispatchToProps)(Cokie);

export default CokieContainer;